import { APIS } from 'config';
import { RequestDocument, Variables, GraphQLClient, gql } from 'graphql-request';
import { ErrorCodes } from '../commonTypes';

export const DEFAULT_ERROR_MESSAGE = 'The action failed. Try again later. If the problem persists, contact Support.';

// TODO: update dictionary with corresponding error messages
export const errorMessages: Record<ErrorCodes, string> = {
  [ErrorCodes.EmailAlreadyExists]: 'User already exists in the system',
  [ErrorCodes.ServerError]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.InvalidRequestError]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.InvalidOperation]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.NameAlreadyExists]: 'Role name already in use, select another name',
  [ErrorCodes.SiteNotActive]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.SiteNotFound]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.UserNotFound]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.RoleNotFound]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.ContactNotFound]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.SiteCreationError]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.UserCreationError]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.RoleCreationError]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.ForbiddenOperationForSiteGuid]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.ForbiddenOperationForUser]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.ParentSiteMustBeSitesContainer]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.SiteMustBeSitesContainer]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.SiteMustHaveAtleastOneContact]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.AllSitesUnderMustBeDeleted]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.AllSitesUnderMustBeHardDeleted]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.RoleHasAssociatedUsers]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.FeatureNotSupported]: DEFAULT_ERROR_MESSAGE,
  [ErrorCodes.ResetPasswordTokenExpired]: 'Your request to reset password has expired.',
  [ErrorCodes.RegistrationTokenExpired]:
    'Your request to complete registration has expired. Contact your admin to get a new invitation.'
};

export const getErrorMessage = (errorCode: ErrorCodes) => errorMessages[errorCode] || DEFAULT_ERROR_MESSAGE;

const graphQLClient = new GraphQLClient(APIS.GQL, { credentials: 'include', mode: 'cors' });

const gqlRequest = async <T = any>(
  query: RequestDocument,
  variables?: Variables | undefined,
  headers?: HeadersInit | undefined
) =>
  graphQLClient.rawRequest<T>(
    gql`
      ${query}
    `,
    variables,
    headers
  );

export default gqlRequest;
